"use strict";
import m from 'mithril';

export default function (container, view) {
    let data = {
        ready: false,
        requestLoginActive: false,
        siteGroups: {
            IVMS: {
                infoActive: false,
                info: m(
                    'p',
                    {},
                    `
Our In Vehicle Monitoring System "IVMS" dashboards provided a curated view of the driving history of your
fleet.  We are experts at processing (both by machine and human) driving rules against your fleet.  We gather your
driving behaviour accurately into these dashboards and provide extra insights into your driving behaviour on a
driver, department or fleet basis.`
                ),
                sites: [
                    {
                        name: 'CSG',
                        requestUrl: 'https://flareivms.northpointfleetmanagement.com.au/request-login',
                        url: 'https://flareivms.northpointfleetmanagement.com.au/'
                    },
                    {
                        name: 'Electranet',
                        requestUrl: 'https://jivms.northpointfleetmanagement.com.au/?p=request-login',
                        url: 'https://jivms.northpointfleetmanagement.com.au/'
                    },
                    {
                        name: 'Origin',
                        requestUrl: 'https://deimosivms.northpointfleetmanagement.com.au/request-login',
                        url: 'https://deimosivms.northpointfleetmanagement.com.au/'
                    },
                    {
                        name: 'Santos',
                        requestUrl: 'https://asteroidivms.northpointfleetmanagement.com.au/?p=request-login',
                        url: 'https://asteroidivms.northpointfleetmanagement.com.au/'
                    }
                ]
            },
            ourFleet: {
                infoActive: false,
                info: m(
                    'p',
                    {},
                    `ourFleet is a Fleet Management tool that provides you with reports and visualisations of your fleet.  This
                covers your Asset Register, the full service history and costs from your Northpoint interactions.  You are also
                able to see detailed reports of your fleet size and lifetimes.  You can easily search for detailed vehicle
                information and reports.`
                ),
                sites: [
                    {
                        name: 'ourFleet',
                        requestUrl: 'https://ourfleet.northpointfleetmanagement.com.au/login/request',
                        url: 'https://ourfleet.northpointfleetmanagement.com.au/'
                    }
                ]
            },
            "Workshop Control": {
                infoActive: false,
                info: m(
                    'p',
                    {},
                    `Northpoint provides you with behind the scenes access into our workshops!  You can see your fleet
                     activity through our workshop.  We display the job cards and operations that are being performed on
                     each vehicle.`
                ),
                sites: [
                    {
                        name: 'ODO',
                        requestUrl: 'https://odo.northpointfleetmanagement.com.au/login/request',
                        url: 'https://odo.northpointfleetmanagement.com.au/'
                    },
                    {
                        name: 'Northpoint Service',
                        requestUrl: 'https://service.northpointfleetmanagement.com.au/login/request',
                        url: 'https://service.northpointfleetmanagement.com.au/'
                    }
                ]
            }
        }
    };

    return {
        exec: () => {
            m.mount(container, {view: () => m(view, data)});
        }
    };
}